import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { QuizResultsCapabilityProvider } from '@sm/question-widgets/respondent-quiz-results';
import SurveyPage from '~app/components/Survey/SurveyPage';

const useStyles = createUseStyles(({ spacing }) => ({
  root: {
    // @todo: replicate theme `$space-exact` value
    margin: [0, 40],
    fontSize: spacing[4],
    overflowWrap: 'break-word',
  },
}));

const SurveyPages = props => {
  const { pages, survey } = props;
  const { root } = useStyles();
  const totalPages = pages.length;
  const pagesElement = pages.map((page, idx) => {
    if (survey[page.id]) {
      return <SurveyPage page={page} survey={survey} pageIndex={idx} totalPages={totalPages} key={`page_${page.id}`} />;
    }
    return null;
  });
  const settings = {
    survey: {
      numberingEnabled: survey.enableNumbering,
      highlightCorrectAnswers: survey.showQuizAnswers,
    },
  };
  return (
    <QuizResultsCapabilityProvider settings={settings}>
      <div className={root} data-testid="SurveyPages__Container">
        <div>{pagesElement}</div>
      </div>
    </QuizResultsCapabilityProvider>
  );
};

SurveyPages.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  survey: PropTypes.shape({
    enableNumbering: PropTypes.bool.isRequired,
    showQuizAnswers: PropTypes.bool.isRequired,
  }),
};

SurveyPages.defaultProps = {
  pages: [],
  survey: null,
};

export default SurveyPages;
